import { makeShop, ShopQuery } from "#web/components/shop/queries/shopQuery";
import { Billing } from "#web/pages/Billing";
import { i18nLike } from "#web/services/i18nLike";
import { Banner } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";

const en = {
  error: {
    description: "Please try again. If the issue persists, please contact support.",
    title: "There was an error loading he shop data",
  },
};

interface SubscriptionGatewayProps {
  children: React.ReactNode;
}

/**
 * The way this gateway works might create a "flash" for the user if they don't have a subscription. It is not ideal,
 * but it is a necessary tradeoff to improve our LCP.
 */
export const SubscriptionGateway = ({ children }: SubscriptionGatewayProps) => {
  const t = i18nLike(en);
  const { data, isError, isFetched } = useQuery(ShopQuery());
  const shop = data ? makeShop(data) : null;

  if (isError) {
    return (
      <Banner title={t("error.title")} tone="critical">
        {t("error.description")}
      </Banner>
    );
  }

  if (isFetched && !shop?.subscription) {
    return <Billing />;
  }

  return <>{children}</>;
};
